import { Controller } from "@hotwired/stimulus"

// Reveals a hidden field wrapper when its checkbox is checked, and clears the
// wrapped input(s) when unchecked — so a value the user typed and then opted
// out of is never submitted.
export default class extends Controller {
  static targets = ["field", "input"]

  toggle(event) {
    if (event.target.checked) {
      this.fieldTarget.classList.remove("hidden")
      this.inputTargets[0]?.focus()
    } else {
      this.fieldTarget.classList.add("hidden")
      this.inputTargets.forEach((input) => { input.value = "" })
    }
  }
}
